import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { useElements, AddressElement } from "@stripe/react-stripe-js";
import { currencies } from "../../../constants/Currencies";

type Props = {
  billingInfo: {
    company_name: string;
    workspace_name: string;
    address: {
      postal_code: number;
      prefecture: string;
      city: string;
      street: string;
      building: string;
    };
    billing_email: string;
  };
  countryCode: string;
};

export type AddressFormRef = {
  getAddressFormData: () => Promise<{
    value: any;
    complete: boolean;
  }>;
};

const AddressForm = forwardRef<AddressFormRef, Props>(({ billingInfo, countryCode }, ref) => {
  const { company_name, address } = billingInfo || {};
  const elements = useElements();

  const getAddressFormData = async (): Promise<{ value: any; complete: boolean }> => {
    const addressElement = elements?.getElement("address");

    if (addressElement) {
      const { value, complete } = await addressElement.getValue();
      return { value, complete };
    }
    return { value: null, complete: false };
  };

  useImperativeHandle(ref, () => ({
    getAddressFormData,
  }));

  return (
    <AddressElement
      options={{
        mode: "billing",
        allowedCountries: currencies.map((currency) => currency.country),
        defaultValues: {
          name: company_name || "",
          address: {
            country: countryCode,
            postal_code: address?.postal_code?.toString() || "",
            state: address?.prefecture || "",
            city: address?.city || "",
            line1: address.street,
            line2: address.building,
          },
        },
      }}
    />
  );
});

export default AddressForm;
